import { useState, useRef, useCallback, useEffect } from 'react'
import { useRouter } from 'next/router'

//* HOCs
import { withUIContext, withUserContext, withDataContext } from 'context'

//* Components
import { Icon, Text, ButtonSimple, FormContainer } from 'components/common'
import { Form, Radio } from 'antd'
import TagFilter from './Tag'

//* Style
import FilterSortByStyle from './style'

const baseFilter = {
    visibility: undefined,
    tag: undefined,
    status: undefined,
    isMyProfile: false,
    sortBy: 'DESC',
    offset: 0,
    userId: 0,
}

const FilterSortBy = ({ handleFunc, isMyProfile, ...props }) => {
    const formRef = useRef()
    const router = useRouter()

    const [sortByPopup, setSortByPopup] = useState(false)
    const [filterBlockPopup, setFilterBlockPopup] = useState(false)

    const [filter, setFilter] = useState({
        ...baseFilter,
        isMyProfile: isMyProfile || baseFilter.isMyProfile,
        userId: props.profileId || props?.user?.id || baseFilter.userId,
    })

    const clickHandler = useCallback((e) => {
        let isExist = e?.path.find((el) => el.classList?.contains('filter-item'))
        if (!!!isExist) {
            setSortByPopup(false)
            setFilterBlockPopup(false)
        }
    }, [])

    const onTabChange = useCallback((activeTab) => {
        props[handleFunc]({
            ...filter,
            type: activeTab,
        })
    }, [filter])

    const onLoadMore = useCallback((offset, activeTab) => {
        props[handleFunc]({
            ...filter,
            type: activeTab,
            offset,
        }, activeTab)
    }, [filter])

    const onSortBy = useCallback((sort) => {
        let data = {
            ...filter,
            sortBy: sort,
            type: props.activeKey
        }

        setFilter(data)
        props[handleFunc](data)
    }, [props.activeKey])


    const onFilter = useCallback(
        (values) => {
            let data = {
                ...filter,
                ...values,
                offset: 0,
                type: props.activeKey
            }

            props.toggleFilter(true)
            setFilter(data)

            setFilterBlockPopup(false)

            return props[handleFunc](data)
        },
        [props.user, props.activeKey])

    const onFilterReset = useCallback(() => {
        formRef.current.resetFields()

        props.toggleFilter(false)

        let data = {
            ...baseFilter,
            isMyProfile: filter.isMyProfile,
            userId: filter.userId,
            type: props.activeKey
        }

        props[handleFunc](data)
        setFilter(data)
        setFilterBlockPopup(false)
    }, [formRef, isMyProfile, props.activeKey])

    useEffect(() => {
        if (sortByPopup || filterBlockPopup) {
            document.addEventListener('click', clickHandler)

            return () => {
                document.removeEventListener('click', clickHandler)
            }
        }
    }, [sortByPopup, filterBlockPopup])

    useEffect(() => {
        setSortByPopup(false)
        setFilterBlockPopup(false)
    }, [router, props.activeKey])

    useEffect(() => {
        if (props.loadMore) {
            props.loadMore.current = onLoadMore
        }
        if (props.tabChange) {
            props.tabChange.current = onTabChange
        }
    }, [filter])

    useEffect(() => {
        if (formRef?.current && !filterBlockPopup) {
            formRef.current.setFields([
                {
                    name: 'visibility',
                    value: filter.visibility,
                },
                {
                    name: 'status',
                    value: filter.status,
                },
            ])
        }
    }, [formRef, filterBlockPopup])

    return (
        <FilterSortByStyle className={`filters flexBox active ${props.activeKey}`}>
            <div
                className='filter-item flexBox alignMiddle cursorPointer'
                onClick={() => {
                    setSortByPopup(!sortByPopup)
                    setFilterBlockPopup(false)
                }}
            >
                <Icon className='op-filter2' />
                {props.winWidth > 1390 && <Text tag='p' className='purple h12 PopSemi' text='Sort by' />}
                <div className={`sort-by-popup flexBoxColumn ${sortByPopup ? 'active' : ''}`}>
                    <Text
                        onClick={() => onSortBy('DESC')}
                        tag='h5'
                        className={`${filter?.sortBy === 'DESC' ? 'purple' : ''} PopReg h5`}
                        text='Recent'
                    />
                    <Text
                        onClick={() => onSortBy('ASC')}
                        tag='h5'
                        className={`${filter?.sortBy === 'ASC' ? 'purple' : ''} PopReg h5`}
                        text='Oldest'
                    />
                    <Text
                        onClick={() => onSortBy('TREND')}
                        tag='h5'
                        className={`${filter?.sortBy === 'TREND' ? 'purple' : ''} PopReg h5`}
                        text='Trendy'
                    />
                </div>
            </div>
            {props.isLoggedIn && (
                <div className={`filter-item flexBox alignMiddle ${(filter.visibility != undefined || filter.status != undefined) && 'selected'} `}>
                    <div
                        onClick={() => {
                            setFilterBlockPopup(!filterBlockPopup)
                            setSortByPopup(false)
                        }}
                        className='flexBox alignMiddle cursorPointer'
                    >
                        <Icon className='op-filter1' />
                        {props.winWidth > 1390 && <Text tag='p' className='purple h12 PopSemi ' text='Filter' />}
                    </div>
                    <div className={`filter-block  ${filterBlockPopup ? 'active' : ''}`}>
                        <FormContainer initialValues={filter} onFinish={onFilter} ref={formRef} className='flexBoxColumn filter-form '>
                            <Text tag='h5' className='h5 PopSemi ant-form-item-label' text='Status' />
                            <Form.Item name={'status'}>
                                <Radio.Group className='in-filter'>
                                    <Radio value={'ongoing'}>
                                        <Text tag='h6' className='h6 PopSemi' text='Ongoing' />
                                    </Radio>
                                    <Radio value={'finished'}>
                                        <Text tag='h6' className='h6 PopSemi' text='Finished' />
                                    </Radio>
                                    {props.isMyProfile && (
                                        <Radio value={'draft'}>
                                            <Text tag='h6' className='h6 PopSemi' text='Draft' />
                                        </Radio>
                                    )}
                                </Radio.Group>
                            </Form.Item>
                            <TagFilter filter={filter} formRef={formRef} />
                            <Text tag='h5' className='h5 PopSemi ant-form-item-label' text='Visibility' />
                            <Form.Item name={'visibility'}>
                                <Radio.Group className='in-filter'>
                                    <Radio value={true}>
                                        <Text tag='h6' className='h6 PopSemi' text='Public' />
                                    </Radio>
                                    <Radio value={false}>
                                        <Text tag='h6' className='h6 PopSemi' text='Private' />
                                    </Radio>
                                </Radio.Group>
                            </Form.Item>
                            <div style={{ width: '100%' }} className='buttons-block flexBox spaceBetween'>
                                <div className='flexBox'>
                                    <ButtonSimple
                                        submit
                                        className='first'
                                        text='Show results'
                                    />
                                    <ButtonSimple
                                        onClick={onFilterReset}
                                        className='grey'
                                        text='Clear all filters'
                                    />
                                </div>
                            </div>
                        </FormContainer>
                    </div>
                </div>
            )}
        </FilterSortByStyle>
    )
}

export default withUIContext(
    withUserContext(withDataContext(FilterSortBy,
        ['getHomeDebates', 'getProfileDebates', 'getSearches', 'toggleFilter']),
        ['isLoggedIn', 'user']),
    ['winWidth']
)
